import { Link } from "react-router-dom";
import { ArrowRight, ClipboardList } from "lucide-react";
import { PageShell } from "@/components/layout/PageShell";
import { Button } from "@/components/ui/button";

export function EmptyAssessmentState({ pageTitle, sectionLabel, message }) {
  return (
    <PageShell>
      <div className="container py-16 lg:py-24">
        <div className="mx-auto max-w-2xl">
          <p className="eyebrow">{sectionLabel}</p>
          <h1 className="mt-3 font-display text-3xl font-medium leading-tight text-foreground sm:text-4xl">
            {pageTitle}
          </h1>
          <p className="mt-4 text-base leading-relaxed text-muted-foreground">{message}</p>
          <div className="paper-card mt-8 flex flex-col gap-4 p-6 sm:p-8">
            <div className="flex items-start gap-3">
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-sm bg-accent-soft text-accent">
                <ClipboardList className="h-5 w-5" />
              </span>
              <div className="space-y-1">
                <p className="font-mono-label text-[11px] uppercase tracking-[0.18em] text-muted-foreground">
                  Next step
                </p>
                <h2 className="font-display text-lg font-medium text-foreground">
                  Complete the readiness intake first
                </h2>
                <p className="text-sm leading-relaxed text-muted-foreground">
                  The intake is consultant-guided and paced to your evidence. No participant identifiers or worker private
                  information are collected. All input stays in your browser session.
                </p>
              </div>
            </div>
            <div className="flex flex-wrap items-center gap-2">
              <Button
                asChild
                className="rounded-sm px-5 text-[13px] font-medium tracking-wide shadow-paper"
              >
                <Link to="/intake">
                  Begin readiness intake
                  <ArrowRight className="h-4 w-4" />
                </Link>
              </Button>
              <Button
                asChild
                variant="ghost"
                className="rounded-sm px-3 text-[13px] font-medium text-foreground hover:bg-secondary"
              >
                <Link to="/">Back to overview</Link>
              </Button>
            </div>
            <p className="border-t border-border pt-4 text-xs leading-relaxed text-muted-foreground">
              NDIS 0138 Readiness is a consultancy readiness tool only. It is not legal advice, an
              Approved Quality Auditor report, an official NDIS Commission tool, a registration
              guarantee, or a compliance certification.
            </p>
          </div>
        </div>
      </div>
    </PageShell>
  );
}
